import * as mutationTypes from './mutationTypes';

const mutations = {
  [mutationTypes.FETCH_VETTINGS](state) {
    state.fetchingVettings = true;
    state.errorFetchingVettings = null;
  },
  [mutationTypes.DONE_FETCHING_VETTINGS](state, { vettings }) {
    state.vettings = vettings;
    state.fetchingVettings = false;
  },
  [mutationTypes.ERROR_FETCHING_VETTINGS](state, { error }) {
    state.errorFetchingVettings = error;
    state.fetchingVettings = false;
  },

  [mutationTypes.CREATE_VETTING_REQUEST](state) {
    state.creatingVetting = true;
    state.errorCreatingVetting = null;
  },
  [mutationTypes.DONE_CREATING_VETTING_REQUEST](state, { vetting }) {
    state.vettings = [...state.vettings, vetting];
    state.creatingVetting = false;
  },
  [mutationTypes.ERROR_CREATING_VETTING_REQUEST](state, { error }) {
    state.errorCreatingVetting = error;
    state.creatingVetting = false;
  },
  [mutationTypes.REMOVE_VETTING_ERROR](state) {
    state.errorCreatingVetting = null;
  },
};

export default mutations;
